import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import {
    IPackage,
    NugetType,
} from '@models';
import {
    CommonNugetService,
    FileDownloadService,
    LibraryService,
    PackageService,
} from '@services';

@Component({
    selector: 'ui-nuget-changelog-list',
    templateUrl: './nuget-changelog-list.html',
    styleUrls: [
        './nuget-changelog-list.scss',
    ],
    providers: [
        CommonNugetService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NugetChangelogListComponent {
    @Input()
    public packageId!: string;

    @Input()
    public nugetService!: LibraryService | PackageService;

    @Input()
    public type!: NugetType;

    @Input()
    public latestVersions!: IPackage[];

    constructor(
        private _commonNugetService: CommonNugetService,
        private _downloadService: FileDownloadService,
    ) { }

    public get isDownloadEnabled(): boolean {
        return this._commonNugetService.isNugetDownloadEnabled(this.type);
    }

    public downloadLink(entry: IPackage) {
        return this.nugetService.downloadLink(entry);
    }

    public downloadPackage(event: MouseEvent, entry: IPackage) {
        event.preventDefault();
        this._downloadService.download(this.nugetService.downloadLink(entry));
    }
}
